import PageComponent from './PageComponent';

class TabComponent extends PageComponent {
}

export default TabComponent;
